export default __webpack_public_path__ + "static/Equilibre_LP_EquilibreLogo-99fb0d7050e220b6098f315c42d74992.png";